module.exports = __webpack_public_path__ + "img/legia-warszawa.949bce1c.png";